module.exports = __webpack_public_path__ + "static/media/oumar1.28aa4065.png";